module.exports = __webpack_public_path__ + "static/media/cadence.4367f629.jpg";